import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import { get } from 'lodash';

import * as ui from '../../../../../redux/actionCreators/sync/ui';
import { updateTemplate, deleteTemplate } from '../../../../../redux/actionCreators/async/emails';
import Modal from '../../../../../common/components/Modal';
import TextField from '../../../../../common/components/c_TextField';
import Textarea from '../../../../../common/components/c_TextArea';

import ToggleButton from '../../../../../common/components/c_ToggleButton';

import Button from '../../../../../common/components/Button';
import cx from 'classnames';

const yesNo = [{value: true, primaryText: 'Yes', subElement: null}, {value: false, primaryText: 'No', subElement: null}];
const htmlview = [{value: true, primaryText: 'preview', subElement: null}, {value: false, primaryText: 'plain text', subElement: null}];

@connect((store) => (
  {staticData: store.staticData}),
  {
    updateTemplate,
    deleteTemplate,
    showSnackBar: ui.showSnackBar,
  }
)
export default class EditEmailTemplate extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    showSnackBar: PropTypes.func.isRequired,
    updateTemplate: PropTypes.func.isRequired,
    deleteTemplate: PropTypes.func.isRequired,
    template: PropTypes.object,
    onUpdate:  PropTypes.func
  }

  constructor() {
    super();
    this.save = :: this.save;
    this.remove = ::  this.remove;
    this.handleClose = :: this.handleClose;
  }

  state = {
    submitted: false,
    htmlview: false,
    enabled: true,
  }

  componentDidMount() {
    this.setState({...this.props.template});
  }

  handleClose = (event) => {
    this.props.onClose && this.props.onClose(event);
  };

  handleUI(prop, label) {

    return {
      'data-id': prop,
      value: this.state[prop],
      floatingLabelText: label,
      onBlur: this.handleChange(prop),
      onChange: this.handleChange(prop),
      isDirty: this.state.submitted,
      errorText: this.validate(prop),
    };
  }

  validate() {
    return;
  }

  handleChange(prop) {
    return (event, value) => {

      if(prop === 'htmlview' && value === false) {
        let html = document.getElementById('email-dialog-editor').innerHTML;
        html = html.replace(/&lt;/g, '<')
                   .replace(/&gt;/g, '>')
                   .replace(/&amp;/g, '&');

        this.setState({html});
      }

      this.setState({ [prop]: value });
    };
  }

  save() {

    const el = document.getElementById('email-dialog-editor');
    let html;

    if(el) {
      html = get(el, 'innerText', '').replace(/\n/g, '<br/>');
    }else {
      html = this.state.html;
    }

    const template = {
      html,
      subject: this.state.subject,
      name: this.state.name,
      enabled: this.state.enabled
    };

    return this.props.updateTemplate(this.state.id, template)
      .then(templates => {
        this.props.showSnackBar();
        this.props.onUpdate(templates);
        this.handleClose();
    });
  }

  remove() {
    return this.props.deleteTemplate(this.state.id)
      .then(templates => {
        this.props.showSnackBar();
        this.props.onUpdate(templates);
        this.handleClose();
    });
  }

  render() {

    return (
       <Modal onClickOut={this.handleClose}>
         <div className='create-email-template-modal'>
         <h1 className='title'>Edit Email Template</h1>

             <TextField className='control-input-text' {...this.handleUI('name', 'Email Template Name')}/>
             <TextField className='control-input-text' {...this.handleUI('subject', 'Subject')}/>

             <ToggleButton
              className='toggle-enabled'
              menuItems={yesNo}
              {...this.handleUI('enabled', 'Enable')}
            />

            {
              <Textarea
                className='email-dialog-editor-plaintext'
                {...this.handleUI('html')}
              >
              </Textarea>
            }

          <div className='email-dialog-actions'>
            <Button label='save' onClick={this.save} />
            <Button className='button-secondary' label='cancel' onClick={this.handleClose} />
            <Button className={ cx('button-delete', {'button-delete-disabled': this.state.system}) } label='delete template' onClick={this.remove} />

          </div>

         </div>
       </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/Emails/Edit/index.js